import Table from '../../../components/common/Table'
import Button from '../../../components/common/Button'

interface Media {
  id: number
  file_name: string
  file_path: string
  mime_type: string
  file_size: number
  alt_text?: string
  title?: string
}

interface Document {
  id: number
  title: string
  description: string
  media_id?: number
  media?: Media
  download_url?: string
  category: string
  position: number
  featured: boolean
  status: 'draft' | 'published'
  created_at: string
}

interface DocumentTableProps {
  documents: Document[]
  onEdit: (doc: Document) => void
  onDelete: (id: number) => void
}

function DocumentTable({ documents, onEdit, onDelete }: DocumentTableProps) {
  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 B'
    const k = 1024
    const sizes = ['B', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
  }

  const columns = [
    {
      key: 'title',
      label: 'Titre',
      render: (doc: Document) => (
        <div>
          <strong>{doc.title}</strong>
          {doc.featured && <span className="badge badge-featured">Mis en avant</span>}
        </div>
      ),
    },
    {
      key: 'file_info',
      label: 'Fichier',
      render: (doc: Document) => (
        <div className="file-info">
          <div className="file-name">{doc.media?.file_name || 'N/A'}</div>
          <div className="file-meta">
            <span className="file-type">{doc.media?.mime_type.toUpperCase() || 'N/A'}</span>
            <span className="file-size">{doc.media?.file_size ? formatFileSize(doc.media.file_size) : 'N/A'}</span>
          </div>
        </div>
      ),
    },
    {
      key: 'description',
      label: 'Description',
      render: (doc: Document) => (
        <div className="document-description">
          {doc.description ? doc.description.substring(0, 80) + (doc.description.length > 80 ? '...' : '') : '-'}
        </div>
      ),
    },
    {
      key: 'position',
      label: 'Position',
    },
    {
      key: 'status',
      label: 'Statut',
      render: (doc: Document) => (
        <span className={`status status-${doc.status}`}>
          {doc.status === 'published' ? 'Publié' : 'Brouillon'}
        </span>
      ),
    },
  ]

  const renderActions = (doc: Document) => (
    <div className="action-buttons">
      <Button
        variant="outline"
        size="small"
        onClick={() => doc.download_url && window.open(doc.download_url, '_blank')}
        title="Télécharger"
        disabled={!doc.download_url}
      >
        📥
      </Button>
      <Button
        variant="outline"
        size="small"
        onClick={() => onEdit(doc)}
        title="Modifier"
      >
        ✏️
      </Button>
      <Button
        variant="outline"
        size="small"
        onClick={() => {
          if (confirm(`Supprimer "${doc.title}" ?`)) {
            onDelete(doc.id)
          }
        }}
        title="Supprimer"
      >
        🗑️
      </Button>
    </div>
  )

  return <Table data={documents} columns={columns} actions={renderActions} />
}

export default DocumentTable
